// Shared helpers + atoms used across the Compensation Center tabs.
// Keeping these in one place avoids drift between sibling tab files.
import { Badge } from '../../components/ui/badge';

export const fmt = (n) =>
  `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const RECORD_STATUS_COLORS = {
  Imported: 'bg-blue-100 text-blue-800',
  Pending_Review: 'bg-amber-100 text-amber-800',
  Accounting_Reviewed: 'bg-indigo-100 text-indigo-800',
  Approved: 'bg-emerald-100 text-emerald-800',
  Scheduled: 'bg-sky-100 text-sky-800',
  Paid: 'bg-green-100 text-green-800',
  Voided: 'bg-zinc-200 text-zinc-700',
};

export const statusBadge = (s) => (
  <Badge className={RECORD_STATUS_COLORS[s] || 'bg-zinc-100 text-zinc-700'} data-testid={`comp-status-${s}`}>{s}</Badge>
);

const STATEMENT_STATUS_COLORS = {
  Draft: 'bg-zinc-100 text-zinc-700',
  Approved: 'bg-emerald-100 text-emerald-800',
  Scheduled: 'bg-sky-100 text-sky-800',
  Paid: 'bg-green-100 text-green-800',
};

export const statementStatusBadge = (s) => (
  <Badge className={STATEMENT_STATUS_COLORS[s] || 'bg-zinc-100 text-zinc-700'} data-testid={`stmt-status-${s}`}>{s}</Badge>
);

const PAYMENT_STATUS_COLORS = {
  Scheduled: 'bg-sky-100 text-sky-800',
  Sent: 'bg-violet-100 text-violet-800',
  Completed: 'bg-green-100 text-green-800',
  Failed: 'bg-red-100 text-red-800',
  Voided: 'bg-zinc-200 text-zinc-700',
};

export const paymentStatusBadge = (s) => (
  <Badge className={PAYMENT_STATUS_COLORS[s] || 'bg-zinc-100 text-zinc-700'} data-testid={`pay-status-${s}`}>{s}</Badge>
);
